import RacesPage from './Races/index';
export default RacesPage;
